"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _uniqueId = require("lodash/uniqueId");

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _c = require("c3/c3.js");

var _c2 = _interopRequireDefault(_c);

var _d3Selection = require("d3-selection");

var _d3Format = require("d3-format");

var d3format = _interopRequireWildcard(_d3Format);

var _labels = require("./labels.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import Share from './share.js';
var logo = require("./images/aculist-edge_logo.png");

var MarketTrends = function (_Component) {
  _inherits(MarketTrends, _Component);

  function MarketTrends(props) {
    _classCallCheck(this, MarketTrends);

    var _this = _possibleConstructorReturn(this, (MarketTrends.__proto__ || Object.getPrototypeOf(MarketTrends)).call(this, props));

    _this.state = {
      btncharttypeactive: "",
      chartType: ""
    };
    _this.handleImageClick = _this.handleImageClick.bind(_this);
    return _this;
  }

  _createClass(MarketTrends, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var btncharttypeactive = this.props.widgetselections.measure.toLowerCase().includes("count") ? "bar" : "spline";
      var chartType = this.props.widgetselections.measure.toLowerCase().includes("count") ? "bar" : "spline";
      this.setState({
        chartType: chartType,
        btncharttypeactive: btncharttypeactive
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var btncharttypeactive = nextProps.widgetselections.measure.toLowerCase().includes("count") ? "bar" : "spline";
      var chartType = nextProps.widgetselections.measure.toLowerCase().includes("count") ? "bar" : "spline";
      this.setState({
        chartType: chartType,
        btncharttypeactive: btncharttypeactive
      });
    }
  }, {
    key: "handleImageClick",
    value: function handleImageClick(e) {
      e.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {

      var logoStyles = {
        height: '16px',
        width: '72px',
        background: "url(" + logo + ")"
      };

      var M2Title = this.props.widgetselections.measure.split(",")[1] === undefined ? '' : " & " + _labels.labels[this.props.widgetselections.measure.split(",")[1]];
      var baseTitle = decodeURIComponent(this.props.widgetselections.geo[0].split(":")[1]) + ' ' + _labels.labels[this.props.widgetselections.measure.split(",")[0]] + M2Title;

      var areaTitle = typeof this.props.data === 'undefined' ? "" : this.props.data.length == 0 ? '' : this.props.widgetselections.geo[0].split(":")[0] == "Area" && this.props.data[0].AreaId != null ? "(MLS AREA" + this.props.data[0].AreaId + ")" : "";
      return _react2.default.createElement(
        "div",
        { className: "titleChartHolder" },
        _react2.default.createElement(
          "div",
          { className: "chartTitle " + (this.props.widgetselections.title === 'false' ? "hidden" : "") },
          baseTitle + areaTitle
        ),
        _react2.default.createElement(
          "div",
          { key: (0, _uniqueId2.default)("marketTrendsChart-"), className: "section_container" },
          _react2.default.createElement(Chart, _extends({}, this.props, {
            id: this.props.id,
            data1: this.props.data,
            widgetselections: this.props.widgetselections,
            chartType: this.state.chartType
          })),
          _react2.default.createElement(
            "div",
            { className: "chartOptionsRow " + this.props.optionclasses },
            _react2.default.createElement(
              "span",
              { className: "externalOptions" },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return MarketTrends;
}(_react.Component);

var Chart = function (_React$Component) {
  _inherits(Chart, _React$Component);

  function Chart() {
    _classCallCheck(this, Chart);

    return _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).apply(this, arguments));
  }

  _createClass(Chart, [{
    key: "componentDidMount",
    value: function componentDidMount() {

      if (this.props.widgetselections.measure.split(",").length == 1) {
        this._updateSingleAxesChart(this.props.data1, this.props.widgetselections, this.props.assets);
      } else if (this.props.widgetselections.measure.includes("Volume")) {
        this._updateChartTotal(this.props.data1, this.props.widgetselections, this.props.assets);
      } else this._updateChart(this.props.data1, this.props.widgetselections, this.props.assets);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.widgetselections.measure.split(",").length == 1) {
        this._updateSingleAxesChart(this.props.data1, this.props.widgetselections, this.props.assets);
      } else if (this.props.widgetselections.measure.includes("Volume")) {
        this._updateChartTotal(this.props.data1, this.props.widgetselections, this.props.assets);
      } else this._updateChart(this.props.data1, this.props.widgetselections, this.props.assets);
    }
  }, {
    key: "_updateChart",
    value: function _updateChart(data1, ws, assets) {
      var _Aculistc3$generate;

      var measurearray = ws.measure.split(",");
      var masterarray = [];
      var periodarray = [];

      var SFarrayM1 = ["SFHM1"];
      var CIarrayM1 = ["C/TM1"];
      var SFarrayM2 = ["SFHM2"];
      var CIarrayM2 = ["C/TM2"];

      var periodarrayasc = [];
      var periodarrayformatted = ["Period"];

      data1.forEach(function (record) {
        if (periodarrayasc.indexOf(record.Period) === -1) {
          periodarrayasc.push(record.Period);
        }
      });
      periodarrayasc.reverse().forEach(function (x) {
        periodarray.push(x);
      });

      periodarray.forEach(function (periodrecord) {
        var filtereddata1 = data1.filter(function (rec) {
          return rec.Period === periodrecord;
        });

        filtereddata1.forEach(function (record) {
          if (filtereddata1.length == 2) {
            record.Class.toLowerCase() == "residential - single family" ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()]) : record.Class.toLowerCase() == "residential - common interest" ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()]) : "";
          } else {
            record.Class.toLowerCase() == "residential - single family" ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()]) && CIarrayM1.push(null) && CIarrayM2.push(null) : record.Class.toLowerCase() == "residential - common interest" ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()]) && SFarrayM1.push(null) && SFarrayM2.push(null) : "";
          }
        });
      });

      if (ws.periodtype.toLowerCase() == "month") {
        var monthnames = {
          "01": "Jan",
          "02": "Feb",
          "03": "Mar",
          "04": "Apr",
          "05": "May",
          "06": "Jun",
          "07": "Jul",
          "08": "Aug",
          "09": "Sep",
          "10": "Oct",
          "11": "Nov",
          "12": "Dec"
        };
        periodarray.forEach(function (periodraw) {
          periodarrayformatted.push(monthnames[periodraw.substring(5)] + " " + periodraw.substring(2, 4));
        });
      } else if (ws.periodtype.toLowerCase() == "quarter") {
        periodarray.forEach(function (periodraw) {
          periodarrayformatted.push(periodraw.substring(4, 6) + " " + periodraw.substring(2, 4));
        });
      } else {
        periodarray.forEach(function (periodrecord) {
          periodarrayformatted.push(periodrecord);
        });
      }

      masterarray.push(periodarrayformatted);

      if (this.props.widgetselections.classtype.split(',').length == 2) {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
        SFarrayM2.length > 1 ? masterarray.push(SFarrayM2) : "";
        CIarrayM2.length > 1 ? masterarray.push(CIarrayM2) : "";
      } else if (this.props.widgetselections.classtype.includes('Single Family')) {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
        SFarrayM2.length > 1 ? masterarray.push(SFarrayM2) : "";
      } else if (this.props.widgetselections.classtype.includes('Common Interest')) {
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
        CIarrayM2.length > 1 ? masterarray.push(CIarrayM2) : "";
      }

      var defaultcolors = ["RGB(86,108,17)", "RGB(208,111,32)", "RGB(0,0,0)", "RGB(255,217,102)"];
      //let defaultcolors=[ 'RGB(126,159,26)', 'RGB(230,145,56)','RGB(0,0,0)', 'RGB(255,217,102)']
      var preferredcolors = [];

      defaultcolors.forEach(function (defcol) {
        if (!preferredcolors.includes(defcol)) {
          preferredcolors.push(defcol);
        }
      });

      _c2.default.chart.internal.fn.getHorizontalAxisHeight = function (axisId) {
        var $$ = this,
            config = $$.config,
            h = 30;
        if (axisId === 'x' && !config.axis_x_show) {
          return 8;
        }
        if (axisId === 'x' && config.axis_x_height) {
          return config.axis_x_height;
        }
        if (axisId === 'y' && !config.axis_y_show) {
          return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1;
        }
        if (axisId === 'y2' && !config.axis_y2_show) {
          return $$.rotated_padding_top;
        }
        // Calculate x axis height when tick rotated
        if (axisId === 'x' && !config.axis_rotated && config.axis_x_tick_rotate) {
          h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_x_tick_rotate)) / 180);
        }
        // Calculate y axis height when tick rotated
        if (axisId === 'y' && config.axis_rotated && config.axis_y_tick_rotate) {
          h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - Math.abs(config.axis_y_tick_rotate)) / 180);
        }
        return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === 'y2' ? -10 : 0);
      };
      var chart = _c2.default.generate((_Aculistc3$generate = {
        padding: { top: 50, left: 50, bottom: 20 },
        bindto: "#" + this.props.id,
        position: "inset"
      }, _defineProperty(_Aculistc3$generate, "padding", {
        top: 40
      }), _defineProperty(_Aculistc3$generate, "data", {
        types: {
          SFHM2: "spline",
          "C/TM2": "spline",
          SFHM1: "bar",
          "C/TM1": "bar"
        },
        x: "Period",
        columns: masterarray,
        axes: {
          SFHM2: "y2",
          "C/TM2": "y2",
          SFHM1: "y",
          "C/TM1": "y"
        },
        labels: "true",
        names: {
          SFHM1: "SFH " + _labels.legendlabels[measurearray[0]],
          "C/TM1": "C/T " + _labels.legendlabels[measurearray[0]],
          SFHM2: "SFH " + _labels.legendlabels[measurearray[1]],
          "C/TM2": "C/T " + _labels.legendlabels[measurearray[1]]
        }
      }), _defineProperty(_Aculistc3$generate, "point", {
        r: 0
      }), _defineProperty(_Aculistc3$generate, "color", {
        pattern: ['#fdb921', '#0033a0']
      }), _defineProperty(_Aculistc3$generate, "axis", {
        y2: {
          // padding:10,
          tick: {

            format: measurearray[1].toLowerCase().includes("over") ? d3format.format(".1%") : measurearray[1].toLowerCase().includes("price") ? d3format.format("$,") : ""
          },
          show: true,
          label: {
            text: _labels.labels[measurearray[1]],
            position: "outer-middle"
          }
        },
        y: {
          //  padding:50,
          tick: {
            outer: false,
            format: measurearray[0].toLowerCase().includes("over") ? d3format.format(".1%") : measurearray[0].toLowerCase().includes("price") ? d3format.format("$,") : ""
          },
          label: {
            text: _labels.labels[measurearray[0]],
            position: "outer-middle"
          }
        },
        x: {
          tick: _defineProperty({
            // type: 'timeseries',
            multiline: false,
            outer: false,
            //  values: [0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,64,128],          
            culling: false,
            rotate: -45
          }, "culling", {
            max: 40
          }),

          type: "category"
          // label: {
          //   text: ws.periodtype,
          //   position: "outer-center",
          //   font: "12px"
          // }
        }
      }), _defineProperty(_Aculistc3$generate, "grid", {
        y: {
          show: true
        }
      }), _defineProperty(_Aculistc3$generate, "zoom", {
        enabled: false
      }), _defineProperty(_Aculistc3$generate, "bar", {
        space: 0.1,
        width: {}
        //  ratio: 0.5,// this makes bar width 50% of length between ticks

        //space:.25
        // or
        //width: 100 // this makes bar width 100px
      }), _Aculistc3$generate));
    }
  }, {
    key: "_updateSingleAxesChart",
    value: function _updateSingleAxesChart(data1, ws, assets) {
      var _Aculistc3$generate2;

      var measurearray = ws.measure.split(",");
      var masterarray = [];
      var periodarray = [];

      var SFarrayM1 = ["SFHM1"];
      var CIarrayM1 = ["C/TM1"];

      var periodarrayasc = [];
      var periodarrayformatted = ["Period"];

      data1.forEach(function (record) {
        if (periodarrayasc.indexOf(record.Period) === -1) {
          periodarrayasc.push(record.Period);
        }
      });
      periodarrayasc.reverse().forEach(function (x) {
        periodarray.push(x);
      });

      periodarray.forEach(function (periodrecord) {
        var filtereddata1 = data1.filter(function (rec) {
          return rec.Period === periodrecord;
        });

        filtereddata1.forEach(function (record) {
          if (filtereddata1.length == 2) {
            record.Class.toLowerCase() == "residential - single family" ? SFarrayM1.push(record[measurearray[0].toString()]) : record.Class.toLowerCase() == "residential - common interest" ? CIarrayM1.push(record[measurearray[0].toString()]) : "";
          } else {
            record.Class.toLowerCase() == "residential - single family" ? SFarrayM1.push(record[measurearray[0].toString()]) && CIarrayM1.push(null) : record.Class.toLowerCase() == "residential - common interest" ? CIarrayM1.push(record[measurearray[0].toString()]) && SFarrayM1.push(null) : "";
          }
        });
      });

      if (ws.periodtype.toLowerCase() == "month") {
        var monthnames = {
          "01": "Jan",
          "02": "Feb",
          "03": "Mar",
          "04": "Apr",
          "05": "May",
          "06": "Jun",
          "07": "Jul",
          "08": "Aug",
          "09": "Sep",
          "10": "Oct",
          "11": "Nov",
          "12": "Dec"
        };
        periodarray.forEach(function (periodraw) {
          periodarrayformatted.push(monthnames[periodraw.substring(5)] + " " + periodraw.substring(2, 4));
        });
      } else if (ws.periodtype.toLowerCase() == "quarter") {
        periodarray.forEach(function (periodraw) {
          periodarrayformatted.push(periodraw.substring(4, 6) + " " + periodraw.substring(2, 4));
        });
      } else {
        periodarray.forEach(function (periodrecord) {
          periodarrayformatted.push(periodrecord);
        });
      }

      masterarray.push(periodarrayformatted);

      if (this.props.widgetselections.classtype.split(',').length == 2) {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
      } else if (this.props.widgetselections.classtype.includes('Single Family')) {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
      } else if (this.props.widgetselections.classtype.includes('Common Interest')) {
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
      }

      var defaultcolors = ["RGB(86,108,17)", "RGB(208,111,32)", "RGB(0,0,0)", "RGB(255,217,102)"];
      //let defaultcolors=[ 'RGB(126,159,26)', 'RGB(230,145,56)','RGB(0,0,0)', 'RGB(255,217,102)']
      var preferredcolors = [];
      assets.filter(function (prefrow) {
        return prefrow.AttributeKey.toLowerCase().includes("vprimcolor") || prefrow.AttributeKey.toLowerCase().includes("vseccolor");
      }).forEach(function (pref) {
        preferredcolors.push(pref.AttributeValue);
      });
      defaultcolors.forEach(function (defcol) {
        if (!preferredcolors.includes(defcol)) {
          preferredcolors.push(defcol);
        }
      });

      var chart = _c2.default.generate((_Aculistc3$generate2 = {
        padding: { top: 50, left: 50, bottom: 20 },
        bindto: "#" + this.props.id,
        position: "inset"
      }, _defineProperty(_Aculistc3$generate2, "padding", {
        top: 40
      }), _defineProperty(_Aculistc3$generate2, "data", {
        types: {
          SFHM1: "bar",
          "C/TM1": "bar"
        },
        x: "Period",
        columns: masterarray,
        axes: {
          SFHM1: "y",
          "C/TM1": "y"
        },
        labels: "true",
        names: {
          SFHM1: "SFH " + _labels.legendlabels[measurearray[0]],
          "C/TM1": "C/T " + _labels.legendlabels[measurearray[0]]

        }
      }), _defineProperty(_Aculistc3$generate2, "point", {
        r: 0
      }), _defineProperty(_Aculistc3$generate2, "color", {
        pattern: ['#b75353', '#12773d', '#4db9ea']
      }), _defineProperty(_Aculistc3$generate2, "axis", {
        y: {
          //  padding:50,
          tick: {
            outer: false,
            format: measurearray[0].toLowerCase().includes("over") ? d3format.format(".0%") : measurearray[0].toLowerCase().includes("price") || measurearray[0] == "SaleVolume" ? d3format.format("$,") : ""
          },
          label: {
            text: _labels.labels[measurearray[0]],
            position: "outer-middle"
          }
        },
        x: {
          tick: {
            multiline: false,
            outer: false
          },

          type: "category",
          label: {
            text: ws.periodtype,
            position: "outer-center",
            font: "12px"
          }
        }
      }), _defineProperty(_Aculistc3$generate2, "grid", {
        y: {
          show: true
        }
      }), _defineProperty(_Aculistc3$generate2, "zoom", {
        enabled: false
      }), _defineProperty(_Aculistc3$generate2, "bar", {
        space: 0.1,
        width: {}
        //  ratio: 0.5,// this makes bar width 50% of length between ticks

        //space:.25
        // or
        //width: 100 // this makes bar width 100px
      }), _Aculistc3$generate2));
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { id: this.props.id, className: "mtchart" },
        "Error"
      );
    }
  }]);

  return Chart;
}(_react2.default.Component);

exports.default = MarketTrends;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-markettrendswidget/lib/MarketTrends.js
// module id = 282
// module chunks = 0